import CampaignCustomFieldResourceModel from '../../generated/types/model/resource/CampaignCustomFieldResourceModel';

export default class CampaignCustomFieldResourceViewModel extends CampaignCustomFieldResourceModel {
  // For instructions on how to use ViewModels visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/155/ViewModels-Models-DTOs
}
